var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiTypography from '@material-ui/core/Typography';
/**
 * Kareo wrapped component of the Material-UI Typography. The prop API has been limited to props defined in TypographyProps.
 *
 * Material-UI Typography: [Typography](https://v4.mui.com/components/typography/), [API](https://v4.mui.com/api/typography/)
 *
 * @storybook: [Typography](http://design.kareoprod.ent/?path=/story/design-system_components-data-display-typography--typography-list)
 */
var Typography = function (props) {
    return React.createElement(MuiTypography, __assign({}, props));
};
Typography.defaultProps = {};
Typography.displayName = 'KareoTypography';
export default Typography;
